<template>
    <div>
        <el-select
                :loading="loading"
                :remote-method="getEmployeeSearchFunc"
                clearable
                filterable
                loading-text="查詢中"
                no-data-text="無資料"
                no-match-text="查無資料"
                placeholder="請輸入要加入的承辦人"
                remote
                size="mini"
                style="margin-right: 2px"
                v-model="newUser"
        >
            <el-option
                    :key="e.userId"
                    :label="`${e.name}(${e.departmentName})`"
                    :value="e.userId"
                    v-for="e in filteredEmployees"
            ></el-option>
        </el-select>
        <el-button
                :disabled="!newUser"
                :loading="loading"
                @click="onInsert"
                icon="el-icon-plus"
                size="mini"
                type="primary"
        >
            新增管理者
        </el-button>
        <el-button :loading="loading"
                   @click="refresh"
                   icon="el-icon-refresh-right"
                   size="mini">
            重新載入
        </el-button>
        <el-table
                :data="pagedData.map((p, idx) => ({idx : idx + 1, ...p}))"
                height="620px"
        >
            <el-table-column
                    label="#"
                    prop="idx"
                    width="50"
            >
            </el-table-column>
            <el-table-column
                    label="使用者"
            >
                <template #default="{row}">
                    {{row.user.name}}
                </template>
            </el-table-column>
            <el-table-column
                    label="權限"
            >
                管理者
            </el-table-column>
            <el-table-column
                    label="異動"
            >
                <template #default="{row}">
                    <el-button
                            :disabled="row.userId === userId"
                            @click="deleteUser(row)"
                            size="small"
                            type="danger"
                    >
                        刪除
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                :page-size="pageSize"
                :total="definitions.length"
                @current-change="page => pageChange(page, news)"
                background
                layout="total, prev, pager, next"
                style="margin-top: 10px;"
                :current-page.sync="currentPage"
        ></el-pagination>
    </div>
</template>

<script>
    import {mapActions, mapState} from 'vuex';
    import PagingMixin from '../../pagingMixin';
    import debounce from 'debounce';
    import {SystemKey} from '../../constants';

    export default {
        name: 'UsersManage',
        data: () => ({
            newUser: undefined
        }),
        mixins: [PagingMixin],
        props: {
            loading: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            ...mapState('claim', ['definitions']),
            ...mapState('auth', ['userId']),
            ...mapState('employee', ['employees']),

            getEmployeeSearchFunc() {
                const self = this;
                return debounce(
                    async (value) => {
                        await self.getEmployeesWithKey(value);
                    },
                    200
                )
            },

            filteredEmployees() {
                return this.employees
                    .filter(e => !this.definitions.some(d => d.userId === e.userId));
            }

        },
        methods: {
            ...mapActions('claim', {
                getClaimDefinitions: 'getClaimDefinitionsAction',
                deleteClaimDefinition: 'deleteClaimDefinitionAction',
                insertClaimDefinition: 'insertClaimDefinitionAction',
            }),

            ...mapActions('employee', {
                getEmployeesWithKey: 'getEmployeesWithKeyAction'
            }),

            async deleteUser({id}) {
                try {
                    await this.$confirm('確定要刪除嗎?', {
                        type: 'danger',
                    });
                    const {success} = await this.deleteClaimDefinition(id);

                    if (success) {
                        this.$message.success('刪除成功');
                    } else {
                        this.$message.warning('刪除失敗，請重試一次');
                    }
                } catch (e) {
                    if (e !== 'cancel') {
                        this.$message({
                            type: 'error',
                            message: '發生錯誤，請重試一次!'
                        });
                    }
                }
            },

            async refresh() {
                await this.getClaimDefinitions();
            },

            async onInsert() {
                if (this.newUser) {
                    const {success} = await this.insertClaimDefinition({
                        userId: this.newUser,
                        value: 'admin',
                        systemKey: SystemKey,
                        user: this.filteredEmployees.find(e => e.userId === this.newUser)
                    });
                    if (success) {
                        this.$message.success('新增成功');
                        this.newUser = undefined;
                    } else {
                        this.$message.warning('新增失敗，請重試一次');
                    }
                } else {
                    this.$message({
                        type: 'warning',
                        message: '請選擇承辦人'
                    })
                }
            }
        },

        watch: {
            definitions(current) {
                this.pagedData = this.pageData(current, 1);
            }
        },

        async created() {
            await this.getClaimDefinitions();
        }
    }
</script>

<style>

</style>